/* istanbul ignore next */
import React, { useId } from "react";

const Identifier = () => (<>{useId()}</>);

export default Identifier;